import * as actionTypes from "../actionTypes";

export const getTestimonials = payload => ({
    type: actionTypes.GET_TESTIMONIALS,
    payload
})

export const setTestimonials = payload => ({
    type: actionTypes.SET_TESTIMONIALS,
    payload
})

export const createTestimonials = payload => ({
    type: actionTypes.CREATE_TESTIMONIALS,
    payload
})

export const updateTestimonials = payload => ({
    type: actionTypes.UPDATE_TESTIMONIALS,
    payload
})

export const deleteTestimonials = payload => ({
    type: actionTypes.DELETE_TESTIMONIALS,
    payload
})

export const changeTestimonialsStatus = payload => ({
    type: actionTypes.CHANGE_TESTIMONIALS_STATUS,
    payload
})